import * as React from 'react'
import { RouterState, RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'

import { StoreState } from '../reducers'
import { Api } from '../services/api/api'

import { AppBarContainer } from './CustomAppBar'

import { AcceptDialog } from '../components/AcceptDialog'

import { Bid, PublishedJobParams } from '../types'

import '../styles/AdditionalItems.scss'
import { ROUTES } from '../constants/routes'
import Lightbox from 'react-images-zoom'
import { FlatButton } from 'material-ui'

import { setJobStatus, setAdditionalItem, statusChangedOnWeb } from '../actions/setJobDetails'
import PageTitle from '../components/PageTitle'
import { AdditionalItem, PictureAdditionalItem } from '../types/AdditionalItem'
import { AdditionalItemStatus } from '../types/enums/AdditionalItemStatus'
import { Actions } from '../constants/components/AcceptDialog'
import images from '../images'

import { StickyContainer, Sticky } from 'react-sticky'
import { JobCategoryNames } from '../constants/jobCategoryNames'

import UploadedImages from '../components/UploadedImages'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import PerfectScrollbar from 'react-perfect-scrollbar'
import ErrorDialog from '../components/ErrorDialog'
import { JobStatus } from '../types/enums'
import {getFormatedPrice} from '../utils/PricingUtils'

interface AdditionalItemsProps {
  routing: RouterState
  routePush: (path: String) => RouterAction
  jobId: string
  jobCategoryName: string
  publishedJobParams: PublishedJobParams
  onSetJobStatus: (status: string) => void
  onSetAdditionalItem: (additionalItem: AdditionalItem) => void
  onStatusChangedOnWeb: () => void
  additionalItem: AdditionalItem
  amount: number
  statusChangedOnWeb: boolean
}

interface AdditionalItemsStates {
  jobId: string
  additionalItem: AdditionalItem
  jobPrice: number
  isAcceptDialogOpen: boolean
  isImagesBoxOpen: boolean
  photoIndex: number
  action?: string
  jobCategoryName: string
  interval?: any
  statusChangedOnWeb: boolean
  isErrorDialogOpen: boolean
  errorMessage: string
  isClientDeclined: boolean
}

export class AdditionalItemsContainer extends React.Component<AdditionalItemsProps, AdditionalItemsStates> {
  constructor(props: any) {
    super(props)
    this.state = {
      jobId: this.props.jobId,
      jobPrice: this.props.amount,
      additionalItem: this.props.additionalItem,
      isAcceptDialogOpen: false,
      isImagesBoxOpen: false,
      photoIndex: 0,
      jobCategoryName: this.props.jobCategoryName,
      statusChangedOnWeb: this.props.statusChangedOnWeb,
      isErrorDialogOpen: false,
      errorMessage: '',
      isClientDeclined: false
    }
  }

  componentDidMount() {
    Api.getJob(this.state.jobId)
      .then((result: any) => {
        this.props.onSetAdditionalItem(result.additionalItem)
        this.setState({
          additionalItem: result.additionalItem,
          jobPrice: result.amount
        })
      })
    if (!this.state.statusChangedOnWeb) {
      this.checkStatusInterval()
    }
  }

  checkStatusInterval = () => {
    let interval = setInterval(() => this.checkStatus(), 1000)
    this.setState({
      interval: interval
    })
    this.checkStatus()
  }

  checkStatus = () => {
    Api.getJob(this.state.jobId)
      .then((result: any) => {
        let status = result.additionalItem.status

        if (result.status !== JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION) {
          if ((status === AdditionalItemStatus.DECLINED && this.state.isClientDeclined) ||
            status === AdditionalItemStatus.ACCEPTED ||
            status === AdditionalItemStatus.CHARGED) {
            this.props.onSetAdditionalItem(result.additionalItem)
            clearInterval(this.state.interval)
            this.props.routePush(ROUTES.BID_ACCEPTED)
          } else if (status === AdditionalItemStatus.DECLINED && !this.state.isClientDeclined) {
            clearInterval(this.state.interval)
            this.setState({
              isErrorDialogOpen: true,
              errorMessage: StringResources.getString(Strings.JobDetails.Errors.Messages.CannotAuthorizeCard)
            })
          }
        }
      })
  }

  setAdditionalItemStatus = (id: string, additionalItem: AdditionalItem) => {
    Api.requestAdditionalItem(id, additionalItem)
      .catch(error => {
        console.log(error)
        this.setState({
          isErrorDialogOpen: true,
          errorMessage: StringResources.getString(Strings.JobDetails.Errors.Messages.CannotAuthorizeCard)
        })
      })
  }

  acceptAdditionalItem = () => {
    this.setState(prevState => {
      let additionalItem = {
        ...prevState.additionalItem,
        status: AdditionalItemStatus.ACCEPTED
      }
      this.setAdditionalItemStatus(this.state.jobId, additionalItem)
      return { ...prevState, additionalItem, isAcceptDialogOpen: false }
    })
  }

  declineAdditionalItem = () => {
    this.setState(prevState => {
      let additionalItem = {
        ...prevState.additionalItem,
        status: AdditionalItemStatus.DECLINED
      }
      this.setAdditionalItemStatus(this.state.jobId, additionalItem)
      return { ...prevState, additionalItem, isAcceptDialogOpen: false, isClientDeclined: true }
    })
  }

  handleAcceptDialogClose = () => {
    this.setState({
      isAcceptDialogOpen: false
    })
  }

  handleAccept = () => {
    this.setState({
      isAcceptDialogOpen: true,
      action: Actions.ACCEPT
    })
  }

  handleDecline = () => {
    this.setState({
      isAcceptDialogOpen: true,
      action: Actions.DECLINE
    })
  }
  onImgBoxClickPrev = () => {
    let { photoIndex, additionalItem } = this.state
    let pictures = additionalItem.pictures as PictureAdditionalItem[]
    this.setState({
      photoIndex: (photoIndex + pictures.length - 1) % pictures.length
    })
  }
  onImgBoxClickNext = () => {
    let { photoIndex, additionalItem } = this.state
    let pictures = additionalItem.pictures as PictureAdditionalItem[]
    this.setState({
      photoIndex: (photoIndex + 1) % pictures.length
    })
  }
  onImgBoxClose = () => {
    this.setState({ isImagesBoxOpen: false })
  }

  onImgIconClick = (event) => {
    // tslint:disable-next-line:radix
    let iconIndex = parseInt(event.target.id)
    this.setState({ photoIndex: iconIndex, isImagesBoxOpen: true })
  }

  handleErrorDialogClose = () => {
    this.setState({
      isErrorDialogOpen: false
    })
    this.props.routePush(ROUTES.BID_ACCEPTED)
  }

  render() {
    let imgSrcs = this.state.additionalItem && this.state.additionalItem.pictures &&
      this.state.additionalItem.pictures.length !== 0 &&
      this.state.additionalItem.pictures.map((picture: PictureAdditionalItem) => {
        return { src: picture.url }
      })
    return (
      <BaseContainer pageName={EventType.ADDITIONAL_ITEM}>
        <Lightbox
          images={imgSrcs ? imgSrcs : []}
          currentImage={this.state.photoIndex}
          showImageCount={true}
          isOpen={this.state.isImagesBoxOpen}
          onClickPrev={this.onImgBoxClickPrev}
          onClickNext={this.onImgBoxClickNext}
          onClose={this.onImgBoxClose}
          rotatable={true}
          zoomable={true}
        />
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={false}
        />
        <ErrorDialog
          handleErrorDialogClose={this.handleErrorDialogClose}
          isErrorDialogOpen={this.state.isErrorDialogOpen}
          errorMessage={this.state.errorMessage}
        />
        <PageTitle text={StringResources.getString(Strings.AdditionalItems.Title)} />
        <PerfectScrollbar className="vertical-scrollbar" >
          <p className="additional-info">
            <img
              src={this.state.jobCategoryName === JobCategoryNames.QUICK_HAUL ? images.quickHaul :
                this.state.jobCategoryName === JobCategoryNames.YARD_DEBRIS ? images.yardDebris :
                  this.state.jobCategoryName === JobCategoryNames.JUNK ? images.junk :
                    this.state.jobCategoryName === JobCategoryNames.RECYCLE ? images.recycle :
                      images.quickHaul
              }
            />
            <span className="text">{StringResources.getString(Strings.AdditionalItems.SubHeader)}</span>
          </p>
          <div className="hauler-comment">{this.state.additionalItem ? this.state.additionalItem.note : ''}</div>
          <div className="title">{StringResources.getString(Strings.AdditionalItems.Titles.ItemPictures)}</div>
          <div className="additional-images">
            {
              this.state.additionalItem && this.state.additionalItem.pictures && this.state.additionalItem.pictures.length !== 0 ?
                this.state.additionalItem.pictures.map((picture: PictureAdditionalItem, index: number) => (
                  <UploadedImages
                    key={picture.id}
                    handleIconClick={this.onImgIconClick}
                    file={picture}
                    index={index}
                    isBadgeNeeded={false}
                  />
                )) : null
            }
          </div>
          <div className="title">{StringResources.getString(Strings.AdditionalItems.Titles.AdditionalPayment)}</div>
          <p className="additional-info">{StringResources.getString(Strings.AdditionalItems.Text.AdditionalPaymentRequest)}
            <span>{
              this.state.additionalItem && this.state.additionalItem.amount !== null ? `$${getFormatedPrice(this.state.additionalItem.amount)}` : null}
            </span>
          </p>
          <ul className="prices">
            <li className="first">{StringResources.getString(Strings.AdditionalItems.Text.OriginalPrice)}</li>
            <li>{StringResources.getString(Strings.AdditionalItems.Text.AdjustedPrice)}</li>
          </ul>
          <ul className="prices">
            <li className="total">{StringResources.getString(Strings.AdditionalItems.Text.Total)}</li>
            <li>{this.state.jobPrice !== 0 ? `$${getFormatedPrice(this.state.jobPrice)}` : null}</li>
            <li>
              {
                this.state.jobPrice !== 0 && this.state.additionalItem &&
                  this.state.additionalItem.amount ? `$${getFormatedPrice(this.state.jobPrice + this.state.additionalItem.amount)}` : null
              }
            </li>
          </ul>
        </PerfectScrollbar>
        {
          this.state.additionalItem && this.state.additionalItem.status === AdditionalItemStatus.IN_PROGRESS ?
            <StickyContainer className="sticky-footer sb" >
              <Sticky>
                {() => (
                  <div className="bottom-part hover">
                    <AcceptDialog
                      isAcceptDialogOpen={this.state.isAcceptDialogOpen}
                      handleDialogClose={this.handleAcceptDialogClose}
                      acceptAdditionalItem={this.acceptAdditionalItem}
                      declineAdditionalItem={this.declineAdditionalItem}
                      action={this.state.action}
                    />
                    <FlatButton
                      label={StringResources.getString(Strings.AdditionalItems.Buttons.Decline.label)}
                      className="flatbutton next"
                      onClick={this.handleDecline}
                    />
                    <FlatButton
                      label={StringResources.getString(Strings.AdditionalItems.Buttons.Accept.label)}
                      className="flatbutton next"
                      onClick={this.handleAccept}
                    />
                  </div>
                )}
              </Sticky>
            </StickyContainer> : null
        }
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    routing: state.routing,
    jobId: state.jobDetails.jobId,
    additionalItem: state.jobDetails.additionalItem,
    amount: state.jobDetails.amount,
    jobCategoryName: state.jobDetails.jobCategoryName,
    statusChangedOnWeb: state.jobDetails.statusChangedOnWeb
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
    onSetAdditionalItem: (additionalItem: AdditionalItem) => dispatch(setAdditionalItem(additionalItem)),
    onStatusChangedOnWeb: () => dispatch(statusChangedOnWeb())
  }
}

export const AdditionalItems = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalItemsContainer)



// WEBPACK FOOTER //
// ./src/containers/AdditionalItems.tsx